import { render, staticRenderFns } from "./PayErrorMsg.vue?vue&type=template&id=c1218d84&scoped=true"
import script from "./PayErrorMsg.vue?vue&type=script&lang=js"
export * from "./PayErrorMsg.vue?vue&type=script&lang=js"
import style0 from "./PayErrorMsg.vue?vue&type=style&index=0&id=c1218d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1218d84",
  null
  
)

export default component.exports